export default __webpack_public_path__ + "static/media/service3.8340db3e.png";